import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Typography } from '@mui/material'
import { useLang } from '~/hooks/useLang'
import DataTables from '~/components/DataTables'
import ICrudIndex from './interfaces/ICrudIndex'
import InternalHeader from '../Layout/components/InternalHeader'
import InternalContent from '../Layout/components/InternalContent'
import FiltersDashboard from './components/FiltersDashboard'
import 'temporal-polyfill/global'
import '@schedule-x/theme-default/dist/index.css'
import '@schedule-x/timezone-select/index.css'
import { useTheme } from '~/hooks/useTheme'
import ActionsViewMode from '~/features/Resources/Schedule/WorkScheduleRegistration/components/ActionsViewMode'
import WorkScheduleCalendar from '~/features/Resources/Schedule/WorkScheduleRegistration/components/WorkScheduleCalendar'
import CheckBoxCrud from './components/CheckBoxGrid'

// eslint-disable-next-line max-lines-per-function
export default function CrudIndex({
  model,
  title,
  exceptColumns,
  forceShowColumns,
  aliasLabel,
  extraActions,
  forceRefresh,
  children,
  stringField,
  booleanField,
  datesField,
  numberField,
  showCreateButton = true,
  desableDelete = false,
  forceOrderColumns,
  arrayField,
  notSortable,
  createTitleComplement,
  deleteable = true,
  forceBooleanField,
  filters,
  loading,
  lockFields,
  clearFilters,
  searchButton,
  disableColumnsFilters,
  editable = true,
  cellLabel,
  createTitleComplete,
  canView = false,
  showInViewMore = [],
  viewTitle,
  priorityActions,
  permissionName,
  codeFields,
  enabledCheckBox,
  handleCheckBox,
  rowsSelected,
  openDialogDeactivatedMultipleUser,
  enableButtonShowResume,
  openModalResultMultipleDeactivatedUsers,
  isScheduleCalendar = false,
  currentViewMode,
  defaultOrder,
  disbaledSearchButton,
  customViewMoreComponent,
  rowActionDisabled,
}: ICrudIndex) {
  const { translate } = useLang()
  const history = useHistory()
  const handleCreateClick = () => {
    history.push(`/${model}/create`)
  }

  const handleShowCalendar = (mode) => {
    currentViewMode?.set(mode)
  }

  const requestFilters = filters?.filter(
    (filterItem) => filterItem.sendToRequest !== false
  )

  return (
    <>
      <InternalHeader
        title={translate(title)}
        action={
          showCreateButton ? (
            <Button
              onClick={handleCreateClick}
              title={translate('Create')}
              variant="contained"
            >
              <Typography variant="body2">
                {createTitleComplete ?
                  translate(createTitleComplete)
                  :
                  translate('Create') + ' ' + translate(createTitleComplement ? createTitleComplement : title)
                }
              </Typography>
            </Button>
          ) : (
            <></>
          )
        }
      />

      <InternalContent expandButton={false}>
        {
          filters && (
            <FiltersDashboard
              loading={loading}
              lockFields={lockFields}
              searchButton={searchButton}
              clearFilters={clearFilters}
              filters={filters}
              disbaledSearchButton={disbaledSearchButton}
            />
          )
        }
        {handleCheckBox && rowsSelected?.get() && (
          <CheckBoxCrud
            enabledCheckBox={enabledCheckBox ?? false}
            handleCheckBox={handleCheckBox}
            openDialogDeactivatedMultipleUser={openDialogDeactivatedMultipleUser}
            rowsSelected={rowsSelected}
            enableButtonShowResume={enableButtonShowResume}
            openModalResultMultipleDeactivatedUsers={openModalResultMultipleDeactivatedUsers}
          />
        )}

        {isScheduleCalendar && (
          <ActionsViewMode
            handleShowCalendar={handleShowCalendar}
            filters={filters}
          />
        )}

        {isScheduleCalendar && currentViewMode?.get() === 'calendar' ?
          <WorkScheduleCalendar
            filters={requestFilters}
            forceRefresh={forceRefresh}
          />
          :
          <DataTables
            model={model}
            exceptColumns={exceptColumns}
            forceShowColumns={forceShowColumns}
            aliasLabel={aliasLabel}
            extraActions={extraActions}
            forceRefresh={forceRefresh}
            stringField={stringField}
            booleanField={booleanField}
            datesField={datesField}
            numberField={numberField}
            desableDelete={desableDelete}
            forceOrderColumns={forceOrderColumns}
            arrayField={arrayField}
            notSortable={notSortable}
            deleteable={deleteable}
            forceBooleanField={forceBooleanField}
            filters={requestFilters}
            disableColumnsFilters={disableColumnsFilters}
            editable={editable}
            cellLabel={cellLabel}
            canView={canView}
            showInViewMore={showInViewMore}
            viewTitle={viewTitle}
            priorityActions={priorityActions}
            permissionName={permissionName}
            codeFields={codeFields}
            enabledCheckBox={enabledCheckBox}
            rowsSelected={rowsSelected}
            defaultOrder={defaultOrder}
            customViewMoreComponent={customViewMoreComponent}
            rowActionDisabled={rowActionDisabled}
          />
        }
      </InternalContent>
      {children}
    </>
  )
}
